module.exports = __webpack_public_path__ + "39d20022d77e9fca9723cd8c832d858a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/centene_2022_chart.png
// module id = 1648
// module chunks = 0